import TH from './TH2';
window.th = new TH();

import App from './App.svelte';
const app = new App({
 	target: document.getElementById('app'),
 	props: {}
});

export default app;

// window.api = async function (data) {
// 	const API_URL = 'http://ws.audioscrobbler.com/2.0/?api_key=c0e426a35756543c062bcb48d621e753&format=json&lang=ru&autocorrect=1&';

// 	let resp = await fetch(API_URL + 'method=artist.getInfo&artist=rammstain', {
// 	  method: 'POST',
// 	  headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
// 	  body: JSON.stringify(data)
// 	});
// 	return resp.json();
// }


// window.api = async function api(data) {
// 	let resp = await fetch('https://trackhunter.deflate.ru/api/', {
// 	  method: 'POST',
// 	  headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
// 	  body: JSON.stringify(data)
// 	});
// 	return resp.json();
// }
  
// api({
// 	artist: 'panzer ag',
// 	method: 'artist.getInfo'
//   }).then(function(json) {
// 	console.log(json);
// })